import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from '@thd-olt-component-react/core-ui';
import { Input } from '@thd-olt-component-react/input';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { Link, Typography } from '@one-thd/sui-atomic-components';
import { EPCContext } from '../../contexts/epcContext';
import { formatPhone } from '../PhoneFieldFormatter/PhoneFieldFormatter';
import './ManageAndModify.scss';
import { addAnalyticEvent } from '../../analytics/common';
import { linkToPrivacyPage } from '../../analytics/outboundLinks';
import LinkButton from '../LinkButton';
import { SECURITY_PATH, ADDRESS_PATH, PRIVACY_PATH } from '../../constants/constants';

export const TooltipContent = () => {

  const handleClick = () => {
    addAnalyticEvent(linkToPrivacyPage);
  };

  return (
    <div className="legal-content">
      <p data-testid="tooltip-content">
        Note you may experience some delays in your request if you have recently
        submitted a request to exercise your privacy rights.
        Please allow sufficient time for your request to be processed.
      </p>
    </div>
  );
};

export function ManageAndModify({ isSearchedInitiated, setToggleNewSearch }) {

  const {
    phone, email
  } = useContext(EPCContext);

  const handleNewSearch = () => {
    setToggleNewSearch(true);
  };

  const handleClick = () => {
    addAnalyticEvent(linkToPrivacyPage);
  };

  return (
    <div className="component">
      <Row>
        <Col className="manage-and-modify-header">
          <h2>Manage Your Preferences</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          <Typography weight="regular">
            You can view and manage your marketing and survey preferences to receive savings and
            project ideas, help us improve our services and products, or to opt out of these
            communications. Use this page to tell us how you’d like to receive these communications.
            These preferences will not affect communications such as: account statements, online
            order details, customer service inquires, etc. The preferences that you have entered
            will be honored in accordance with our
            <Link
              weight="regular"
              underline="always"
              href={PRIVACY_PATH}
              onClick={handleClick}
            >
              &nbsp;Privacy and Security Statement
            </Link>.
            <br />
            <br />
            You can update your email and phone number in the&nbsp;
            <Link underline="always" href={SECURITY_PATH}>Security & Password</Link>
            &nbsp;section, and your mailing address in the&nbsp;
            <Link underline="always" href={ADDRESS_PATH}>Addresses</Link>
            &nbsp;section by logging in to your account.
          </Typography>
        </Col>
      </Row>

      {isSearchedInitiated && (
        <div>
          <Row>
            <Col>
              <h2>Your Personal Information</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              {email && (
                <div key={email}>
                  <Input
                    type="text"
                    header="Email Address"
                    className="searchInput"
                    defaultValue={email}
                    disabled
                  />
                </div>
              )}
              {phone && (
                <div key={phone}>
                  <Input
                    type="text"
                    header="Phone Number"
                    className="searchInput"
                    defaultValue={formatPhone(phone)}
                    disabled
                  />
                </div>
              )}
            </Col>
          </Row>
          <Row>
            <Col lg={4} fallback={6}>
              <Button outline onClick={handleNewSearch}>New Search</Button>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
}

ManageAndModify.propTypes = {
  isSearchedInitiated: PropTypes.bool.isRequired,
  setToggleNewSearch: PropTypes.func.isRequired,
};
